// Copyright (c) 2017 Deere & Company

import PipStatuses from '../state/pip-statuses';
import actions from '../actions-list';
import {getDefaultPipStatuses} from '../../shared/services/criteria';
import {getDefaultState} from '../state';
import {updateKeyValueSelectionList} from '../../../shared/services/list-selections';

const updateAllPipStatuses = state => {

    const toggleSelectedPipTypesState = state.selected.length > 0 ? [] : state.allowed;

    return PipStatuses.update(state, {
        selected: {
            $set: toggleSelectedPipTypesState
        }
    });

};

const updatePipStatuses = (state, action) =>
    PipStatuses.update(state, {
        allowed: {
            $set: action.pipStatuses
        },
        selected: {
            $set: getDefaultPipStatuses(action.pipStatuses)
        }
    });

const updatePipStatus = (state, action) =>
    PipStatuses.update(state, {
        selected: {
            $set: updateKeyValueSelectionList(
                action.status,
                action.isSelected,
                state.selected
            )
        }
    });

export default (state = getDefaultState().pipStatuses, action) => {

    const actionTypes = {
        [actions.RESET_OPEN_PIP_PROGRAMS_REPORT_PIP_STATUS_CRITERIA]: updatePipStatuses,
        [actions.UPDATE_ALL_OPEN_PIP_PROGRAMS_REPORT_PIP_STATUS_SELECTIONS]: updateAllPipStatuses,
        [actions.UPDATE_OPEN_PIP_PROGRAMS_REPORT_PIP_STATUS]: updatePipStatuses,
        [actions.UPDATE_OPEN_PIP_PROGRAMS_REPORT_PIP_STATUS_SELECTION]: updatePipStatus
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/reports/open-pip-programs/reducers/pip-statuses.js